import { ColyseusSDK } from '@colyseus/sdk'
import type { WorldRoomLike, WorldTransport } from './world-connection'

/** O transporte de verdade: o SDK do Colyseus, um cliente por endpoint. */
export const colyseusTransport: WorldTransport = async (endpoint, roomId, options) => {
  const client = new ColyseusSDK(endpoint)
  return (await client.joinById(roomId, options)) as unknown as WorldRoomLike
}
